import React, { useState, useEffect } from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { projectFirestore } from '../firebase/config';

const DEFAULTS = {
  description: 'معرض التصوير لكلية التربية النوعية',
  emails: ['info-lighttale2022@gmail.com', 'gallery.lighttale2022@gmail.com'],
  socialLinks: {
    twitter: 'http://twitter.com/AliShakrany',
    facebook: 'http://fb.com/lighttale2022',
    whatsapp: 'https://api.whatsapp.com/send/?phone=201555090521&text&app_absent=0',
  },
};

export default function App() {
  const [footerData, setFooterData] = useState(DEFAULTS);
  const [siteTitle, setSiteTitle] = useState('حكاية ضوء');

  useEffect(() => {
    const unsub1 = projectFirestore.collection('settings').doc('footer')
      .onSnapshot((doc) => {
        if (doc.exists) {
          const d = doc.data();
          setFooterData({
            description: d.description || DEFAULTS.description,
            emails: d.emails || DEFAULTS.emails,
            socialLinks: { ...DEFAULTS.socialLinks, ...(d.socialLinks || {}) },
          });
        }
      });
    const unsub2 = projectFirestore.collection('settings').doc('site')
      .onSnapshot((doc) => {
        if (doc.exists && doc.data().siteTitle) setSiteTitle(doc.data().siteTitle);
      });
    return () => { unsub1(); unsub2(); };
  }, []);

  return (<>
    <div style={{ paddingTop:20}}></div>
    <MDBFooter className='footer-upgraded text-white text-center text-lg-left'>
      <MDBContainer className='p-4'>
        <MDBRow>
          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>{siteTitle}</h5>
            <p style={{fontSize: '0.95rem', opacity: 0.85, lineHeight: 1.8}}>
              {footerData.description} لعام {new Date().getFullYear()}
            </p>
            <a href="/">
              <img src="/logof.svg" width="120" height="90" alt={siteTitle} />
            </a>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>روابط سريعة</h5>
            <ul className='list-unstyled mb-0'>
              <li><a href='/' className='te widget20'>الرئيسية</a></li>
              <li><a href='gallery' className='te widget20'>المعرض</a></li>
              <li><a href='contact-us' className='te widget20'>تواصل معنا</a></li>
              <li><a href='about-us' className='te widget20'>عن الموقع</a></li>
              <li><a href='goals' className='te widget20'>الاهداف</a></li>
            </ul>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase mb-0'>تواصل معنا</h5>
            <ul className='list-unstyled' style={{fontSize: '0.95rem', opacity: 0.85, lineHeight: 2}}>
              {footerData.emails.map((email, i) => (
                <li key={i}>{email}</li>
              ))}
            </ul>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <div className="widget">
              <ul className="footer-social nav-item list-unstyled d-flex justify-content-center gap-2">
                {footerData.socialLinks.twitter && (
                  <li><a href={footerData.socialLinks.twitter}><span className="fab fa-twitter widget30"></span></a></li>
                )}
                {footerData.socialLinks.facebook && (
                  <li><a href={footerData.socialLinks.facebook}><span className="fab fa-facebook widget30"></span></a></li>
                )}
                {footerData.socialLinks.whatsapp && (
                  <li><a href={footerData.socialLinks.whatsapp}><span className="fab fa-whatsapp widget30"></span></a></li>
                )}
              </ul>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
         جميع الحقوق محفوظة:{' '}
         {siteTitle}
         &copy; {new Date().getFullYear()}
      </div>
    </MDBFooter>
  </>);
}